import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {VoidDto} from "../dto/void.dto";
import {UrlBuilder} from "../item/url.item";
import {map} from "rxjs/operators";
import {FrontendErrorDto} from "../dto/frontend-error.dto";

@Injectable({providedIn: 'root'})
export class ErrorRepo {

  private readonly errorWrite = '/v1/error/dash';

  private readonly http = inject(HttpClient);

  // noinspection JSUnusedGlobalSymbols
  public submitErrors(errors: FrontendErrorDto[]): Observable<WrapperDto<VoidDto>> {
    const url = UrlBuilder.builder().addPath(this.errorWrite).build();
    return this.http.post<WrapperDto<VoidDto>>(url.getUrl(), errors, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }
}
